module.exports = __webpack_public_path__ + "static/media/expected-balance.019b5fa1.svg";